import notificationApi from "../api/notification-api";

const add = async (payload) => {
    debugger;
    // console.log(' add payload ', payload);
    const resp = await notificationApi.add(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    debugger;
    // console.log(' edit payload ', payload);
    const resp = await notificationApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await notificationApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await notificationApi.search(condition, pagination);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const notificationService = {
    add,
    edit,
    remove,
    search
};

export default notificationService;